module.exports = __webpack_public_path__ + "img/图5.4917a00e.jpg";